import { render, staticRenderFns } from "./UpdateCorrespondenceThreadContractorModal.vue?vue&type=template&id=2cadd0cf&"
import script from "./UpdateCorrespondenceThreadContractorModal.vue?vue&type=script&lang=js&"
export * from "./UpdateCorrespondenceThreadContractorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports